<template>
  <span class="bui-nav-ico" :style="sizeStyle">
    <slot />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    size?: number;
  }>(),
  { size: 40 },
);

const sizeStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<style lang="scss" scoped>
.bui-nav-ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--nav-padding-icon, 8px);
  flex-shrink: 0;
  color: var(--nav-label-primary, #f6f7ff);
  // SVG inside should fill the inner box.
  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}
</style>
